// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3IYRZ","content":"Consent_content__2bye-","footer":"Consent_footer__yxXKk"};